import { MedicalCaseProcessedContent } from '../../../domain/medical-case/model';
import { buildProcessedDocumentPageAnchors } from '../../../shared/util/processed-document-page-anchor.util';

export class MedicalCaseProcessedContentUtil {
  static toText(content: MedicalCaseProcessedContent): string {
    if (typeof content === 'string') {
      return content;
    }

    const anchoredPageNumbers = new Set<number>();

    return content
      .flatMap(document =>
        document.pages.map(
          page =>
            `${buildProcessedDocumentPageAnchors(page, anchoredPageNumbers)}# ${document.documentFilename} (page ${page.pageNumber})\n\n${page.content}`
        )
      )
      .join('\n\n');
  }
}
